<script>
	import LazyImg from "./LazyImg.svelte";

	export let heading;
	export let text;
	export let image;
	export let imageCaption;
	export let imageCredit;
	export let top;

	let textPrepared = "";
	if (text) {
		textPrepared = text.replaceAll("'", '"');
		textPrepared = textPrepared.replaceAll(
			'<img class="icon" src="',
			'<img class="icon" src="' + PATH
		);
		textPrepared = textPrepared.replaceAll("{{{", '<span class="highlight white">');
		textPrepared = textPrepared.replaceAll("}}}", "</span>");
		textPrepared = textPrepared.replaceAll("{{", '<span class="highlight red">');
		textPrepared = textPrepared.replaceAll("}}", "</span>");
		textPrepared = textPrepared.replaceAll("{", '<span class="highlight">');
		textPrepared = textPrepared.replaceAll("}", "</span>");
	}
</script>

<div class="slide" style:top={top + "px"}>
	<div class="content">
		<div class="heading">{heading}</div>
		{#if image}
			<div class="image-container">
				<LazyImg class="image" src="{PATH}/images/{image}" />
				{#if imageCaption || imageCredit}
					<div class="image-subline">
						<!--{#if imageCaption} <div class="image-caption">{imageCaption}</div>{/if}-->
						{#if imageCredit} <div class="image-credit">{imageCredit}</div>{/if}
					</div>
				{/if}
			</div>
		{/if}
		{#if textPrepared} <div class="text">{@html textPrepared}</div>{/if}
	</div>
</div>

<style>
	.slide {
		position: absolute;
		left: 40px;
		width: 550px;
		border-radius: 4px;
		margin-bottom: 20px;
		padding: 30px 20px;
		color: #fff;
		overflow: hidden;
		z-index: 2;

		background: rgba(21, 26, 39, 0.35);
		-webkit-backdrop-filter: blur(35px);
		backdrop-filter: blur(35px);
	}

	:global(.tsil-feature-not-backdropfilter) .slide {
		background: rgba(21, 26, 39, 0.7);
	}

	@media (orientation: landscape) {
		:global(.portrait-only) {
			display: none;
		}
	}

	@media (orientation: portrait) {
		:global(.landscape-only) {
			display: none;
		}
	}

	.image-container {
		margin-bottom: 30px;
		position: relative;
	}

	.heading {
		font-weight: 700;
		font-size: 24px;
		line-height: 30px;
		margin-bottom: 20px;
	}

	@media (orientation: landscape) and (max-width: 1300px) {
		.slide {
			left: 20px;
			width: 415px;
			padding: 30px 15px;
			font-size: 18px;
			line-height: 27px;
		}

		.image-container {
			margin-bottom: 20px;
			margin-top: 20px;
		}

		.heading {
			margin-bottom: 15px;
		}
	}

	@media (orientation: portrait) and (min-width: 591px) and (max-width: 850px) {
		.slide {
			margin-top: 30vh;
		}
	}

	@media (orientation: portrait) {
		.slide {
			left: calc(50% - 295px);
		}
	}

	@media (min-width: 591px) and (max-width: 850px) {
		.slide {
			left: calc(50% - 295px);
		}
	}

	@media (max-width: 590px) {
		.slide {
			left: 9px;
			width: calc(100% - 18px);
			box-sizing: border-box;
		}
	}

	.image-subline {
		/*
		display: flex;
    justify-content: space-between;
    */
		/*
		font-size: 14px;
		line-height: 18px;
    margin-top: 10px;
    */
		position: absolute;
		bottom: 2px;
		right: 2px;

		font-size: 10px;
		line-height: 10px;
		font-family: "Franklin Gothic FS", Helvetica, Arial, sans-serif;
	}

	.image-caption {
		font-size: 14px;

		display: inline;
		margin-right: 3px;
	}

	.image-credit {
		color: #848484;
		/*font-size: 14px;*/
		font-size: 10px;
		line-height: 10px;
		opacity: 0.6;

		display: inline;
	}

	.text {
		font-size: 20px;
		line-height: 28px;
		font-weight: 400;
	}

	:global(.image) {
		width: 100%;
	}

	:global(.highlight) {
		color: #f7ca20;
		font-weight: 700;
		padding: 0 2px 0 2px;
		/* white-space: nowrap; */
	}

	:global(.highlight.red) {
		color: #cd0100;
	}

	:global(.highlight.white) {
		color: #fff;
	}

	:global(.icon) {
		margin: 0 4px 4px 0;
		vertical-align: middle;
		max-height: 16px;
		width: 16px;
	}

	:global(span.nowrap) {
		white-space: nowrap;
	}

	@media (max-width: 480px) {
		.text {
			font-size: 17px;
			line-height: 26px;
		}

		.slide {
			padding: 18px 15px;
		}

		.heading {
			margin-bottom: 10px;
		}

		.image-container {
			margin-bottom: 10px;
		}

		.scrolly :global(a.mapboxgl-ctrl-logo) {
			width: 88px;
			height: 23px;
			margin: 0 0 -4px -4px;
			display: block;
			background-repeat: no-repeat;
			cursor: pointer;
			overflow: hidden;
			background-image: url(data:image/svg+xml;charset=utf-8;base64,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);
		}
	}
</style>
